import { CSVImporter } from 'csv-import-react';
import Modal from '../Modal';
import { useState } from 'react';
import Loading from '../Loading';
import FileImportModal from '../FileImportModal.jsx';
import useBusinessPostApi from '../../lib/useBusinessPostApi.js';
import * as Toast from '../../lib/Toast.js';
import { useCustomFieldsSchemaQuery } from '~/lib/Queries';
import { ObjectTypes } from '~/lib/ObjectTypes';

const ImportGiftCertificatesModal = ({ isOpen, onClose, onSuccess }) => {
    const { save, isSaving } = useBusinessPostApi(`/import/gift-certificates`);

    function doSave(data) {
        return save({ rows: data }).then(result => {
            Toast.success(
                `Successfully imported ${result.count} gift certificates${result.skipped > 0 ? `, skipped ${result.skipped} because they were missing an email or had no value` : ''}`,
            );
            onSuccess();
        });
    }

    return (
        <FileImportModal
            isOpen={isOpen}
            onClose={onClose}
            doSave={doSave}
            title="Import Gift Certificates"
            template={{
                columns: [
                    {
                        name: 'Purchaser First Name',
                        key: 'first_name',
                        required: false,
                        suggested_mappings: ['First'],
                    },
                    {
                        name: 'Purchaser Last Name',
                        key: 'last_name',
                        required: false,
                        suggested_mappings: ['Last'],
                    },
                    {
                        name: 'Purchaser Email',
                        key: 'email',
                        required: true,
                        suggested_mappings: ['Email', 'E-mail'],
                    },
                    {
                        name: 'Amount',
                        key: 'amount',
                        required: true,
                        suggested_mappings: ['Amount'],
                    },
                    {
                        name: 'Code',
                        key: 'code',
                        required: false,
                        suggested_mappings: ['Code'],
                        description:
                            'Code to redeem gift certificate, if not provided then one will be randomly generated',
                    },
                    {
                        name: 'Expiration Date',
                        key: 'expires',
                        required: false,
                        suggested_mappings: ['Expires'],
                    },
                ],
            }}
        />
    );
};

export default ImportGiftCertificatesModal;
